export type AnalyticsLabState = 'ready' | 'too-few' | 'empty' | 'error' | 'dense';

const VALID: AnalyticsLabState[] = ['ready', 'too-few', 'empty', 'error', 'dense'];

/**
 * Reads ?state= from the analytics Visual Lab chapter URL.
 */
export function parseAnalyticsLabQuery(search: string): AnalyticsLabState {
  const raw = new URLSearchParams(search).get('state') ?? 'too-few';
  if (VALID.includes(raw as AnalyticsLabState)) {
    return raw as AnalyticsLabState;
  }
  return 'too-few';
}

export function analyticsLabStateToFixtureState(
  state: Exclude<AnalyticsLabState, 'dense'>,
): 'ready' | 'tooFew' | 'empty' | 'error' {
  if (state === 'too-few') return 'tooFew';
  return state;
}
